module.exports = __webpack_public_path__ + "static/hero-image-mobile-e49ced2aea35c8d644b0ce78d8895860.jpg";